import { useEffect, useState, useRef } from 'react';
import { collection, query, orderBy, limit, startAfter, getDocs } from 'firebase/firestore';
import { storage, firestore, auth }  from "../firebase/firebase.js";

var unique = 0;

export function useInfiniteDebateFeed(lastDoc, setLastDoc, batchSize = 10, ) {
  const [arenas, setArenas] = useState([]);

  const [loading, setLoading] = useState(false);
  const hasMore = useRef(true);

  const loadMore = async () => {
    if (unique) return;
    if (loading || !hasMore.current) return;
	unique = 1;
    setLoading(true);

    const baseQuery = query(collection(firestore, 'arenas'), orderBy('createdAt', 'desc'), ...(lastDoc ? [startAfter(lastDoc)] : []), limit(batchSize));

    const snap = await getDocs(baseQuery);
    const fetched = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setArenas(prev => [...prev, ...fetched]);


    if (snap.docs.length < batchSize) {
     hasMore.current = false;
    }

    setLastDoc(snap.docs[snap.docs.length - 1]);
    setLoading(false);
	unique = 0;
  };

  useEffect(() => { loadMore(); }, []);

  return { arenas, loadMore, loading, hasMore: hasMore.current };
}
